import logoBackground from 'assets/logo-bg.svg'
import logoBackgroundOrange from 'assets/logo-orange-angle.svg'
import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    showCard: {
        display: 'flex',
        flexDirection: 'column',
        background: 'white',
        position: 'relative',
        textAlign: 'center',
        zIndex: theme.zIndexLevels.two,

        '&::before,&::after': {
            content: '""',
            display: 'block',
            height: 117,
            width: '100%',
            position: 'absolute',
        },

        '&::before': {
            backgroundImage: 'linear-gradient(#f9ac18, #f77731)',
        },

        '&::after': {
            borderBottom: '6px solid rgba(255, 255, 255, .7)',
            backgroundClip: 'border-box',
            zIndex: 1,
        },
    },

    showCardRecent: {
        height: 430,
        '&::after': {
            backgroundImage: `url(${logoBackground})`,
            backgroundPosition: 'left bottom',
            backgroundSize: 800,
            backgroundColor: '#252d3d',
        },
    },
    showCardUpcoming: {
        '&::after': {
            backgroundImage: `url(${logoBackgroundOrange}), linear-gradient(#f9ac18, #f77731)`,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
        },
        height: 530,
    },

    showCardContent: {
        position: 'absolute',
        zIndex: theme.zIndexLevels.two,
        padding: 24,
        paddingTop: 48,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
        height: '100%',
        width: '100%',
    },
    ticketContent: {
        paddingBottom: 65,
        '&::before, &::after': {
            content: '""',
            display: 'inline-block',
            height: 40,
            width: 21,
            position: 'absolute',
            bottom: 20,
            background: 'rgb(13,17,22)',
        },
        '&::after': {
            left: -2,
            boxShadow: 'inset -2px 0px 3px rgba(0, 0, 0, .2)',
            borderTopRightRadius: 21,
            borderBottomRightRadius: 21,
        },
        '&::before': {
            right: -2,
            boxShadow: 'inset 2px 0px 3px rgba(0, 0, 0, .2)',
            borderTopLeftRadius: 21,
            borderBottomLeftRadius: 21,
        },
    },
    title: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: '18px',
    },
    description: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: '14px',
        color: theme.colors.light.darkgrey,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
    },
    showDateAndTime: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        color: theme.colors.light.darkgrey,
        fontSize: '14px',
    },
    btn: {
        marginLeft: 'auto',
        height: 32,
        width: '100%',
    },
    img: {
        width: 120,
        height: 120,
        marginBottom: 24,
        objectFit: 'cover',
        borderRadius: 8,
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
    },
    showCardBorder: {
        height: 6,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        opacity: 0.6,
        backgroundImage: theme.gradients.yellowToPink,
    },
}))
